// extracted by mini-css-extract-plugin
export default {"checkbox":"customCheckbox_checkbox__guL8m","checkmark":"customCheckbox_checkmark__wzwsK"};